import type { CollapseProps } from 'antd'
import { Collapse } from 'antd'
import cn from 'classnames'
import styled from '@emotion/styled'
import { Icon } from '../../base/Icon'

const StyledCollapse = styled(Collapse)`
  &.ant-collapse-small
    > .ant-collapse-item
    > .ant-collapse-content
    > .ant-collapse-content-box {
    padding: 0 0 2px 12px;
  }
  .ant-collapse .ant-collapse-content > .ant-collapse-content-box {
    padding: 4px 0 4px 38px;
  }

  .ant-collapse-header:hover {
    background: rgba(98, 105, 153, 0.08);
    border-radius: 8px !important;
  }
`

export function LoggerCollapse(props: CollapseProps) {
  return (
    <StyledCollapse
      ghost
      expandIcon={({ isActive }) => (
        <Icon
          path='arrow.svg'
          className={cn(
            'transition-transform-200 text-font_1 w-[10px] object-contain scale-[1.71]',
            {
              'rotate-0': isActive,
              '-rotate-90': !isActive,
            },
          )}
        />
      )}
      {...props}
    />
  )
}
